import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class CostDocumentItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  index!: number | null;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  currency!: string | null;
  @IsNumber()
  @Expose()
  quantity!: number;
  @IsNumber()
  @Expose()
  netPrice!: number;
  @IsNumber()
  @Expose()
  netPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  netValue!: number;
  @IsNumber()
  @Expose()
  netValueInCurrency!: number;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  exchangeRate!: number;
  @IsBoolean()
  @Expose()
  isSettled!: boolean;
  @IsNumber()
  @Expose()
  pairAmount!: number;
}

export class CostDocumentPreview {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  receiptDate!: string;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  formOfPaymentName!: string | null;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  exchangeDate!: string;
  @IsNumber()
  @Expose()
  exchangeRate!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsString()
  @Expose()
  createAt!: string;
  @IsString()
  @Expose()
  createBy!: string;
}

export class CostDocumentDetails {
  @IsOptional()
  @IsString()
  @Expose()
  contractor!: null | string;

  @Type(() => CostDocumentPreview)
  @ValidateNested()
  @Expose()
  costDocumentDetailsItems!: CostDocumentPreview;

  @Type(() => CostDocumentItem)
  @ValidateNested()
  @Expose()
  costDocumentItems!: Array<CostDocumentItem>;
}
